import { render, staticRenderFns } from "./BaseNotificator.vue?vue&type=template&id=a7003fb4"
import script from "./BaseNotificator.vue?vue&type=script&lang=js"
export * from "./BaseNotificator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports